import { Box, FormHelperText, Grid, Typography } from "@mui/material";
import EventInfo from "../../Components/EvenInfo";
import { useState } from "react";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import PasswordField from "../../Components/InputFields/Password";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import { loginActionAdmin } from "../../Store/Actions/Login";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import MobileField from "../../Components/InputFields/Phone";

export default function LoginForm() {
  const [loading, setLoading] = useState();
  const [formError, setFormError] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object({
    mobile: Yup.string("Enter your mobile")
      .matches(phoneRegExp, "Phone number is not valid")
      .required("mobile is required"),
    countryCode: Yup.string().max(20).required("+20"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      mobile: "",
      countryCode: "20",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        if (loading) return;
        setFormError("");
        setLoading(true);

        const response = await dispatch(
          loginActionAdmin({
            countryCode: undefined,
            mobile: values.countryCode + values.mobile,
            password: values.password,
          })
        );

        if (response.status !== 200) {
          setFormError(response);
          return setLoading(false);
        } else {
          setLoading(false);
          return navigate("/dashboard");
        }
      } catch (error) {
        setFormError(error);
        setLoading(false);
      }
    },
  });

  return (
    <Box
      sx={{
        backgroundImage: 'url("./images/registrationBg.png")',
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        p: { xs: "2em", lg: "4em" },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        bgcolor: "#000",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: "2em", md: 0 },
        minHeight: "100vh",
      }}
    >
      <EventInfo />
      <Box
        sx={{
          bgcolor: "#00000029",
          borderRadius: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          p: "2em",
          gap: "1em",
          flex: 1,
          backgroundColor: "rgba(233, 233, 233, 0.88)",
          "& .MuiTextField-root": {
            "& .MuiInputBase-root": {
              backgroundColor: "white",
            },
          },
        }}
      >
        <img src="./images/pyxizBlueLogo.png" alt="" />
        <Typography
          variant="h5"
          sx={{
            width: "100%",
            textAlign: "left",
            color: "#202020",
          }}
        >
          <span style={{ color: "#25AAE1" }}>Welcome</span> back!
        </Typography>

        <form onSubmit={formik.handleSubmit} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MobileField formik={formik} />
            </Grid>

            <Grid item xs={12}>
              <PasswordField
                name="password"
                icon="./images/lock.svg"
                placeholder="Password"
                formik={formik}
              />
            </Grid>

            {/* <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "end", width: "100%" }}
              >
                <Button
                  variant="text"
                  sx={{
                    bgcolor: "none",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                  }}
                  onClick={() => navigate("/forgot-password")}
                >
                  <Typography
                    variant="button"
                    sx={{
                      textDecoration: "underline",
                      color: "#202020",
                    }}
                  >
                    Forgot Password?
                  </Typography>
                </Button>
              </Box>
            </Grid> */}

            {formError && (
              <Grid item xs={12}>
                <FormHelperText
                  sx={{
                    color: "red",
                    fontWeight: 600,
                    textAlign: "center",
                  }}
                >
                  {formError}
                </FormHelperText>
              </Grid>
            )}

            <Grid item xs={12}>
              <SubmitButton text={"Login"} disabled={loading} />
            </Grid>
          </Grid>
        </form>
        {/* <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "end",
            gap: "0.5em",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: "#202020",
            }}
          >
            Don't have an account?
          </Typography>
          <Button
            component={Link}
            to={"/register"}
            variant="text"
            sx={{
              p: 0,
              bgcolor: "none",
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Typography variant="subtitle1" sx={{ color: "#25AAE1" }}>
              Register Now
            </Typography>
          </Button>
        </Box> */}
      </Box>
    </Box>
  );
}
